import React from "react";
import { Box, Pagination, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const PaginationShape = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Pagination Shape
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          A basic menu opens over the anchor element by default (this option can
          be changed via props). When close to a screen edge, a basic menu
          vertically realigns to make sure that all menu items are completely
          visible.
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          language="js"
          title={"'circular' | 'rounded' Pagination"}
          value={" <Pagination count={10} />\n" +
              "            <Pagination count={10} shape={\"rounded\"} />"}
        >
          <Stack direction={"column"} spacing={2}>
            <Pagination count={10} />
            <Pagination count={10} shape={"rounded"} />
          </Stack>
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default PaginationShape;
